import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const SpotlightCardMobile = ({ data }) => {
  const router = useRouter()

  // Extract banner image, profile picture, store name, description, and products
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const description =
    data?.description ||
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

  const handleMerchButton = () => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch`)
    }
  }

  const handleProfileButton = () => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}`)
    }
  }

  return (
    <div className={styles.borderContainer}>
      <div className={styles.container}>
        <div className="w-full h-[234px] md:h-[320px] overflow-hidden flex items-center gap-[9px]">
          <ImageWithFoster src={storeImage} className="w-full h-full overflow-hidden object-cover" />
        </div>
        <div className={styles.rightSection}>
          <div className={styles.username} onClick={() => router.push(`/${data?.creatorUsername}`)}>
            {data?.creatorUsername}
          </div>
          {/* <div className="w-full">
            {data?.name && data?.name.length > 0 && <div className={styles.title}>{data?.name}</div>}
          </div> */}
          <div className="w-full mt-[8px]">
            <div className={styles.description}>{description}</div>
          </div>
          <div className="w-full absolute bottom-[23px] left-0 px-[16px] flex gap-[15px]">
            <div className={styles.merchButton} onClick={handleMerchButton}>
              Merch Store
            </div>
            <div className={styles.profileButton} onClick={handleProfileButton}>
              View Profile
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SpotlightCardMobile
